import { motion } from "framer-motion";
import { resolveImg } from "@/lib/api";

export default function PageBanner({ image, overline, title, subtitle }) {
  return (
    <section className="relative min-h-[62vh] sm:min-h-[70vh] flex items-end overflow-hidden" data-testid="page-banner">
      <motion.img
        src={resolveImg(image)}
        alt={title}
        initial={{ scale: 1.12, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-vm-bg via-vm-bg/60 to-black/30" />
      <div className="relative z-10 w-full max-w-7xl mx-auto px-5 sm:px-8 pb-10 sm:pb-16">
        {overline && (
          <motion.span initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }} className="block text-xs tracking-[0.3em] uppercase text-vm-gold mb-3">
            {overline}
          </motion.span>
        )}
        <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3 }} className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight max-w-3xl">
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.45 }} className="mt-4 text-base sm:text-lg text-vm-fg/85 max-w-xl leading-relaxed">
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
